import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Book, queryFilter } from '@/modules/Book/interfaces/book'
import { showErrors } from '@/utils/snack'

import BookDialog from './book-dialog'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { getBooks } from '@/modules/Book/gql/book.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppTextField,
    AppRefresh
  }
})
export default class BooksList extends mixins(BookDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Settings'
    },
    {
      text: 'Books'
    }
  ]
  searchVal = ''
  books: Book[] = []
  ifRelatedList = false

  orderBy: {
    [key: string]: string
  } = {
    name: 'NAME',
    id: 'ID'
  }

  tableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name_default' },
      sortable: true,
      resizable: true
    }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  get filter (): queryFilter {
    return {
      name: this.searchVal ? this.searchVal : null
    }
  }

  mounted () {
    this.getBooks()
  }

  async getBooks () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getBooks,
        variables: {
          filter: this.filter,
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.tableOptions.loading = false
      this.books = result.data.getBooks.books
      this.tableOptions.tablePage.total = result.data.getBooks.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  refreshList () {
    this.searchVal = ''
    this.getBooks()
  }

  async deleteBookConfirm () {
    await this.deleteBookPost()
    this.getBooks()
  }

  routeToDetail (item: any) {
    return {
      name: 'BookDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getBooks()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getBooks()
  }
}
